import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-rank',
  },
  {
    name: 'Artist',
    key: 'artist',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-artist',
  },
  {
    name: 'Track',
    key: 'track',
    size: 'medium',
    sortable: true,
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-track',
  },
  {
    name: 'Passengers',
    key: 'passengers',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengers',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengerPoolPer',
  },
];

const data = [
  {
    rank: '1',
    artist: 'Drake',
    track: 'Janice STFU',
    passengers: {
      display: '9,860',
      sort: 9860,
    },
    passenger_pool_per: '1.97%',
  },
  {
    rank: '2',
    artist: 'Ella Langley',
    track: "Chossin'Texas",
    passengers: {
      display: '9,437',
      sort: 9437,
    },
    passenger_pool_per: '1.89%',
  },
  {
    rank: '3',
    artist: 'Olivia Rodrigo',
    track: 'Drop Dead',
    passengers: {
      display: '8,069',
      sort: 8069,
    },
    passenger_pool_per: '1.61%',
  },
  {
    rank: '4',
    artist: 'BTS',
    track: 'Swim',
    passengers: {
      display: '7,466',
      sort: 7466,
    },
    passenger_pool_per: '1.50%',
  },
  {
    rank: '5',
    artist: 'Bruno Mars',
    track: 'I Just Might',
    passengers: {
      display: '7,386',
      sort: 7386,
    },
    passenger_pool_per: '1.47%',
  },
];

const AudioTracks = () => {
  const [filterData, setFilterData] = useState(data);
  const [filters, setFilters] = useState(defaultUsageFilters);

  useEffect(() => {
    const { searchText } = filters;
    const filteredData = data.filter((obj) => {
      return obj.artist.toLowerCase().startsWith(searchText?.toLowerCase());
    });
    setFilterData(filteredData);
  }, [filters]);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-AudioTracks-Header" className="title_1">
            Audio tracks
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={filterData}
                  onRowClick={() => {}}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AudioTracks;
